@if (crew) {
<div class="row">
  <!-- Left panel -->
  <div class="col-md-3">
    <mat-card class="p-2"
      appearance="outlined">
      <mat-card-content>
        <div class="text-center mb-4">
          <app-material-image-viewer
            [documentId]="crew?.photoDocumentId ?? ''"
            [alt]="crew?.firstName"
            class="round-photo img-fluid">
          </app-material-image-viewer>
        </div>
        <div class="text-center">
          <h5
            class="my-2 text-capitalize fw-semibold d-flex align-items-center justify-content-center gap-2">
            <span>{{ crew.firstName }} {{ crew.middleName }}
              {{ crew.lastName }}</span>
            <div [ngClass]="getCrewStatus()"></div>
          </h5>
          <p class="mb-5 text-muted">
            <b class="text-dark">
              {{ getLastCrewChange(crew.crewChanges)?.rank }}
            </b>
            <span class="mx-2"> at </span>
            <b class="text-dark">
              {{ getLastCrewChange(crew.crewChanges)?.vesselName }}
            </b>
          </p>
          <p class="text-secondary fw-medium me-2">
            {{
            getOrganisation(
            getLastCrewChange(crew.crewChanges)?.contract
            ?.managementOrganisationId
            )?.nameTranslations["en"]
            }}
          </p>
          <!-- Rating -->
          <div class="d-flex flex-column align-items-center my-1">
            <div class="d-flex align-items-center justify-content-center">
              @for (r of rate[0]; track $index) {
              <mat-icon class="fs-3 me-0 text-warning">star</mat-icon>
              }
              @for (r of rate[1]; track $index) {
              <mat-icon class="fs-4 me-0">star_border</mat-icon>
              }
              <small>{{ rate[2] }} of {{ appraisals.length }} appraisal(s)</small>
            </div>
          </div>
        </div>
        <mat-divider class="my-2"></mat-divider>
        <div class="table-responsive">
          <table class="table table-borderless align-middle mb-0">
            <tbody>
              <!-- Age -->
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">calendar_today</mat-icon>
                </td>
                <td class="fw-medium text-muted">Age</td>
                <td>{{ calculateAge() }}</td>
                <td class="text-end"></td>
              </tr>
              <!-- Contact -->
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">phone</mat-icon>
                </td>
                <td class="fw-medium text-muted">Contact No.</td>
                <td>{{ crew.contactNumber }}</td>
                <td class="text-end"></td>
              </tr>
              <!-- Nationality -->
              @if (nationality) {
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">flag</mat-icon>
                </td>
                <td class="fw-medium text-muted">Nationality</td>
                <td>{{ nationalityFormatter(nationality) }}</td>
                <td class="text-end"></td>
              </tr>
              }
              <!-- Status -->
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">
                    {{ getStatus() === 'On-board' ? 'verified_user' : 'hourglass_empty' }}
                  </mat-icon>
                </td>
                <td class="fw-medium text-muted">Status</td>
                <td>{{ getStatus() }}</td>
                <td class="text-end"></td>
              </tr>
              <!-- Seaman -->
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">directions_boat</mat-icon>
                </td>
                <td class="fw-medium text-muted">Seaman</td>
                <td>
                  @if (crew.seamanDetails?.number) {
                  {{ crew.seamanDetails.number }}
                  @if (crew.seamanDetails?.expirationDate) {
                  | {{ crew.seamanDetails.expirationDate }}
                  }
                  }
                </td>
                <td class="text-end">
                  <button mat-icon-button
                    matTooltip="View Seaman"
                    (click)="showSeaman = true">
                    <mat-icon class="text-secondary">attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up [(show)]="showSeaman"
                    [fileId]="crew.seamanDetails?.fileId ?? ''"
                    [title]="'Seaman'">
                  </app-material-pdf-viewer-pop-up>
                </td>
              </tr>
              <!-- Passport -->
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">assignment_ind</mat-icon>
                </td>
                <td class="fw-medium text-muted">Passport</td>
                <td>
                  @if (crew.passportDetails?.number) {
                  {{ crew.passportDetails.number }}
                  @if (crew.passportDetails?.expirationDate) {
                  | {{ crew.passportDetails.expirationDate }}
                  }
                  }
                </td>
                <td class="text-end">
                  <button mat-icon-button
                    matTooltip="View Passport"
                    (click)="showPassport = true">
                    <mat-icon class="text-secondary">attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up [(show)]="showPassport"
                    [fileId]="crew.passportDetails?.fileId ?? ''"
                    [title]="'Passport'">
                  </app-material-pdf-viewer-pop-up>
                </td>
              </tr>
              <!-- CV -->
              @if (crew.cvDocumentId) {
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-secondary">description</mat-icon>
                </td>
                <td class="fw-medium text-muted">CV</td>
                <td></td>
                <td class="text-end">
                  <button mat-icon-button
                    matTooltip="View CV"
                    (click)="showCv = true">
                    <mat-icon class="text-secondary">attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up [(show)]="showCv"
                    [fileId]="crew.cvDocumentId"
                    [title]="'CV'">
                  </app-material-pdf-viewer-pop-up>
                </td>
              </tr>
              }
              <!-- Credentials -->
              @for (credential of crew.credentials; track $index; let i = $index) {
              <tr class="border-bottom">
                <td class="text-center">
                  <mat-icon class="text-primary">badge</mat-icon>
                </td>
                <td class="fw-medium text-muted">
                  {{ getCredentialsLabel(credential.documentName) }}
                </td>
                <td>
                  {{ credential?.number }} <br />
                  {{ credential?.expirationDate }}
                </td>
                <td class="text-end">
                  <button mat-icon-button
                    matTooltip="View Document"
                    (click)="showDocs[i] = true">
                    <mat-icon>attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up [(show)]="showDocs[i]"
                    [fileId]="credential.documentName"
                    [title]="getCredentialsLabel(credential.documentName) ?? '' ">
                  </app-material-pdf-viewer-pop-up>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <!-- Right panel -->
  @if (crew && crew.crewChanges.length > 0) {
  <div class="col-md-9">
    <mat-card appearance="outlined">
      <mat-card-header class="m-2">
        <mat-card-title class="m-3 my-3 fw-semibold">Crew Changes</mat-card-title>
      </mat-card-header>
      <mat-card-content class="pd-2">
        <div class="table-responsive">
          <table class="table table-striped table-hover align-middle">
            <thead class="bg-light text-muted text-center">
              <tr>
                <th>Rank</th>
                <th>Vessel</th>
                <th>Voyage</th>
                <th>Management</th>
                <th>On Board</th>
                <th>Off Board</th>
                <th>Salary</th>
                <th class="text-center">Edit</th>
              </tr>
            </thead>
            <tbody class="text-center">
              @for (c of crew.crewChanges; track $index) {
              <tr>
                <td>{{ c.rank }}</td>
                <td>{{ c.vesselName }}</td>
                <td>{{ c.voyageNumber }}</td>
                <td>
                  {{getOrganisation(c?.contract?.managementOrganisationId)
                  ?.nameTranslations["en"]}}
                </td>
                <td>
                  {{ planPlace(c, "On Board") }}<br />{{
                  planTime(c, "On Board")
                  }}
                </td>
                <td>
                  {{ planPlace(c, "Off Board") }}
                </td>
                <td>{{ getLatestContractSalary(c) }}</td>
                <td class="text-center">
                  <a [routerLink]="[
                      '/vessels/crew-change/crew-change-data-entry/',
                      crew.id,
                      c.id
                    ]">
                    <mat-icon class="fs-5 text-secondary">edit</mat-icon>
                  </a>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
    <!--Appraisal-->
    @if (appraisals && appraisals.length > 0) {
    <div class="row">
      <div class="col-12 col-md-12">
        <mat-card class="mt-3 shadow-sm rounded-3"
          appearance="outlined">
          <mat-card-header class="m-2">
            <mat-card-title class="m-2 fw-semibold">Appraisal</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pd-2">
            <table class="table table-striped table-hover align-middle">
              <thead class="bg-light text-muted text-center">
                <tr class="text-center">
                  <th>Assessor</th>
                  <th>Date</th>
                  <th>Overal grade</th>
                  <th>Document</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody class="text-center">
                @for (appraisal of appraisals; track $index; let i = $index) {
                <tr>
                  <td>{{ findCrew(appraisal.masterId) }}</td>
                  <td>{{ formatDatestring(appraisal.date) }}</td>
                  <td>{{ calculateRating([appraisal])[2] }}</td>
                  <td>
                    <a (click)="downLoadDocument(appraisal.documentId)">
                      <i class="fa fa-download"></i>
                    </a>
                  </td>
                  <td>
                    <a data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      (click)="showAppraisalPreview(appraisal)">
                      <i class="fa fa-paperclip fa-external-link"></i>
                    </a>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    }
    <div class="row">
      <!-- Timeline -->
      <div class="col-lg-4 col-md-12 mb-3">
        <mat-card class="mt-3">
          <app-timeline [timelineHeader]="'Crew Changes Timeline'"
            [timelineItems]="crewChangeTimeline">
          </app-timeline>
        </mat-card>
      </div>
      <!--Remarks-->
      <div class="col-lg-8 col-md-12 mb-3">
        @if (crew.remarks && crew.remarks.length > 0 && showRemarkDoc) {
        <mat-card appearance="outlined" class="mt-3">
          <mat-card-header class="m-2">
            <mat-card-title class="m-3 my-3 fw-semibold">Remarks</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pd-2">
            <div class="table-responsive">
              <table class="table table-striped table-hover align-middle">
                <thead class="bg-light text-muted text-center">
                  <tr>
                    <th>Status</th>
                    <th>Author</th>
                    <th>Comment</th>
                    <th>Date</th>
                    <th>Document</th>
                  </tr>
                </thead>
                  <tbody>
                  @for (remark of crew.remarks; track $index; let i = $index) {
                    <tr>
                    <td>{{ remark.status }} </td>
                    <td>{{ findCrew(remark.author || '') }}</td>
                    <td>{{ remark.comment }}</td>
                    <td class="text-end">{{ remark.date }}</td>
                    <td>
                    @if (remark.docId) {
                    <button
                    class="ms-4"
                    mat-icon-button
                    color="primary"
                    matTooltip="View Remark Document"
                    (click)="showRemarkDoc[i] = true"
                    >
                    <mat-icon class="fs-4">open_in_new</mat-icon>
                    </button>
                    }
                    @if (remark.docId) {
                    <app-material-pdf-viewer-pop-up
                    [(show)]="showRemarkDoc[i]"
                    [fileId]="remark.docId"
                    [title]="'Remark document'"
                    >
                    </app-material-pdf-viewer-pop-up>
                    }
                    </td>
                    </tr>
                  }
                  </tbody>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
        }
      </div>
    </div>
    @if (appraisal) {
    <div class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"
              id="loadingModalLabel">
              {{ crew?.firstName }} {{ crew.lastName }} Appraisal submitted on
              {{ appraisal.date }}
            </h5>
            <button type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Grade</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                @for (item of appraisal.appraisals; track $index) {
                <tr>
                  <td>{{ item.item }}</td>
                  <td>{{ item.grade?.toLocaleUpperCase() }}</td>
                  <td>{{ item.remark }}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>

}